export function jqScrollEvents() {

  jQuery(function () {

    // //top header visible
    // $(window).on('scroll', function() {
    //   var kv = $('.p-indexHero');
    //   var topHeader = $('.top_header');
    
    //   // .kvの画面上端からの位置とスクロール量を取得
    //   var kvBottom = kv.offset().top + kv.outerHeight();
    //   var scrollTop = $(window).scrollTop();
    
    //   // .kvが画面から消えたかどうか（スクロール位置がkvの下端を超えたか）
    //   if (scrollTop > kvBottom) {
    //     topHeader.addClass('is-visible');
    //   } else {
    //     topHeader.removeClass('is-visible');
    //   }
    // });

  });

}